import { NgZone } from '@angular/core';
import { Scheduler } from 'rxjs/Scheduler';
import { Action } from 'rxjs/scheduler/Action';
import { Subscription } from 'rxjs/Subscription';

// This is needed for Protractor
class LeaveZoneScheduler {
  constructor(private zone: NgZone, private scheduler: Scheduler) {}

  schedule<T>(
    work: (this: Action<T>, state?: T) => void,
    delay?: number,
    state?: T,
  ): Subscription {
    return this.zone.runOutsideAngular(() =>
      this.scheduler.schedule(work, delay, state),
    );
  }
}

class EnterZoneScheduler {
  constructor(private zone: NgZone, private scheduler: Scheduler) {}

  schedule<T>(
    work: (this: Action<T>, state?: T) => void,
    delay?: number,
    state?: T,
  ): Subscription {
    return this.zone.run(() => this.scheduler.schedule(work, delay, state));
  }
}

export function leaveZone(zone: NgZone, scheduler: Scheduler): Scheduler {
  return new LeaveZoneScheduler(zone, scheduler) as any;
}

export function enterZone(zone: NgZone, scheduler: Scheduler): Scheduler {
  return new EnterZoneScheduler(zone, scheduler) as any;
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/th/webapp/src/app/@shared/datastore/zone-util.ts